import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { resolveUpdatePropertyError } from '../actions/ConversationsTaxonomyActions';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyUpdateErrorAlert = () => {
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsx(Alert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.taxonomy.alert.update.title"
    }),
    type: "danger",
    closeable: true,
    onClose: () => dispatch(resolveUpdatePropertyError()),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.taxonomy.alert.update.body"
    })
  });
};
export default PropertyUpdateErrorAlert;